import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// @mui
import { Box, Stack, Drawer, Typography } from '@mui/material';
// hooks
import useResponsive from '../../../hooks/useResponsive';
// config
import { APP_VERSION, CONFIG_SETTINGS, NAV } from '../../../config';
// components
import Scrollbar from '../../../components/scrollbar';
import { NavSectionVertical } from '../../../components/nav-section';
//
import navConfig from './config';
//import NavDocs from './NavDocs';
import NavAccount from './NavAccount';
import Logo from '../../../components/brandbook/Logo';
import LogoLarge from '../../../components/brandbook/LogoLarge';
import Scrollbars from 'react-custom-scrollbars';

// ----------------------------------------------------------------------

NavVertical.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};

export default function NavVertical({ openNav, onCloseNav }) {
  const { pathname } = useLocation();

  const isDesktop = useResponsive('up', 'lg');

  //console.log(navConfig)

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Box
      sx={{
        height: 1,
        '& .simplebar-content': {
          height: 1,
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <Stack
        spacing={3}
        sx={{
          pt: 3,
          pb: 2,
          px: 2.5,
          flexShrink: 0,
        }}
      >
        <NavAccount />
      </Stack>

      <NavSectionVertical data={navConfig} />

      <Box sx={{ flexGrow: 1 }} />

      {/*<NavDocs />*/}
    </Box>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_DASHBOARD },
        position:'relative'
      }}
    >
      {isDesktop ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              width: NAV.W_DASHBOARD,
              color:'white',
              bgcolor: theme => theme.palette.primary.main,
              borderRightStyle: 'dashed',
            },
          }}
        >
          <Scrollbars autoHeight autoHeightMin='100%'>
            {renderContent}
          </Scrollbars>
          <VersionApp />
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: {
              width: NAV.W_DASHBOARD,
              bgcolor: theme => theme.palette.primary.main,
            },
          }}
        >
          {renderContent}
          <VersionApp />
        </Drawer>
      )}
      
    </Box>
  );
}

const VersionApp = () => {
  return(
    <Typography variant='subtitle2' align='center' color='white' sx={{
      position:'fixed',
      bottom:0, left:0,
      zIndex:1000,
      px:2,
      pb:2,
      //border:'1px solid white',
      width:280,
      boxSizing:'border-box'
    }}>
      Velfare App v{APP_VERSION}
    </Typography>
  )
}
